import axios from 'axios'
import { host } from './config'
import { removeEmpty, transformBoolValuesToInt } from '@/helper'
const stringify = require('qs-stringify')
export const http = axios.create({
  baseURL: host,
  headers: {
    'Content-type': 'application/json',
    Accept: 'application/json',
  },
})
export const apiUrl = {
  baseUrl: '/api/v1/site',
  auth: '/api/v1/site/auth',
  logout: '/api/v1/site/logout',
  flats: '/api/v1/site/flats',
  favoriteFlats: '/api/v1/site/flats/favorites',
}
class ApiCreate {
  constructor() {
    this.getToken()
  }

  getToken() {
    const token = localStorage.getItem('token')
    if (token) http.defaults.headers.common.authorization = `Bearer ${token}`
  }

  saveToken(data) {
    localStorage.setItem('token', data.access_token)
    http.defaults.headers.common.authorization = `Bearer ${localStorage.getItem(
      'token'
    )}`
  }

  logOutUser() {
    return http
      .post(apiUrl.auth + '/logout')
      .then((response) => {
        localStorage.removeItem('token')
        return Promise.resolve(response)
      })
      .catch((error) => {
        console.log('API LOGOUT error')
        return Promise.reject(error)
      })
  }

  fetchFlatsFilterParams() {
    return http
      .get(apiUrl.baseUrl + '/filter-parameter')
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  fetchFlatsList(params) {
    return http
      .get(apiUrl.flats, params)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  fetchFlatByID(id) {
    return http
      .get(apiUrl.flats + '/' + id)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  registerUser(data) {
    return http
      .post(apiUrl.auth + '/register', data)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  loginUser(data) {
    return http
      .post(apiUrl.auth + '/login', data)
      .then((res) => {
        this.saveToken(res.data)
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  verifyPhone(data) {
    return http
      .post(apiUrl.auth + '/verify', data)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  forgotPasswordSMS(data) {
    return http
      .post(apiUrl.auth + '/password/sms', data)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  resetPassword(data) {
    return http
      .post(apiUrl.auth + '/password/reset', data)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  fetchMeInfo() {
    return http
      .post(apiUrl.auth + '/me')
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  fetchLogoData() {
    return http
      .get(apiUrl.baseUrl + '/logo')
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  fetchSettings() {
    return http
      .get(apiUrl.baseUrl + '/settings')
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  sendFeedback(data) {
    return http
      .post(apiUrl.baseUrl + '/feedback', data)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  sendAdvertisement(data) {
    return http
      .post(apiUrl.baseUrl + '/adverts', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  fetchPageContentBySlug(slug) {
    return http
      .get(apiUrl.baseUrl + '/pages/' + slug)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  fetchFavoriteFlatList(params) {
    return http
      .get(apiUrl.favoriteFlats, params)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  
  addToFavoriteFlatList(id,sort) {
    return http.post(apiUrl.favoriteFlats + '/' + id, { status: sort } )
    .catch((error) =>
      Promise.reject(
        error.response.data.errors || error.response.data.message))
  }
  deleteFromFavoriteFlatList(id) {
    return http
      .delete(apiUrl.favoriteFlats + '/' + id)
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  moveTopFavorite(id) {
    return http
      .patch(apiUrl.favoriteFlats + '/' + id + '/top')
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
  moveBottomFavorite(id) {
    return http
      .patch(apiUrl.favoriteFlats + '/' + id + '/bottom')
      .then((res) => {
        return Promise.resolve(res)
      })
      .catch((error) =>
        Promise.reject(
          error.response.data.errors || error.response.data.message
        )
      )
  }
}


function refreshToken() {
  return http
    .post(apiUrl.auth + '/refresh', {})
    .then((token) => {
      console.log('REFRESH TOKEN', token.data.access_token)
      localStorage.setItem('token', token.data.access_token)
      http.defaults.headers.common.authorization = `Bearer ${token.data.access_token}`
      return Promise.resolve(token.data.access_token)
    })
    .catch((error) => {
      localStorage.removeItem('token')
      //location.href = '/'
      Promise.reject(error.response.data.errors || error.response.data.message)
    })
}

let isRefreshing = false
const refreshSubscribers = []

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb)
}

function onRrefreshed(token) {
  refreshSubscribers.map((cb) => cb(token))
}
http.interceptors.request.use((config) => {
  config.paramsSerializer = (params) =>
    stringify(transformBoolValuesToInt(removeEmpty(params)))
  return config
})
http.interceptors.response.use(
  (response) => response,
  (error) => {
    const {
      config,
      response: { status },
    } = error
    const originalRequest = config

    if (status === 401 && !originalRequest.url.includes('auth/login')) {
      if (!isRefreshing) {
        isRefreshing = true
        refreshToken().then((newToken) => {
          isRefreshing = false
          onRrefreshed(newToken)
        })
      }
      const retryOrigReq = new Promise((resolve, reject) => {
        subscribeTokenRefresh((token) => {
          originalRequest.headers.authorization = `Bearer ${token}`
          resolve(axios(originalRequest))
        })
      })
      return retryOrigReq
    } else if (status === 500) {
      // Vue.toasted.show('Internal server error! please try later!', {position:'bottom-right', duration:3600, type:'error'});
      return Promise.reject(error)
    } else if (status === 429) {
      // Vue.toasted.show('Too many attempts! please wait a minute!', {position:'bottom-right', duration:3600, type:'info'});
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

export const Api = new ApiCreate()
